interface Props {
  data: any;
}
function Manifest({ data }: Props) {
  return (
    <div className='ubbe-card h-100'>
      <div className='ubbe-card-header'>
        <h5 className='ps-3 mb-0 GlobalBoxHead'>Manifest</h5>
      </div>
      <div className='card-body pt-2 p-4 h-auto'>
        <div className='row'>
          <div className='col-md-6'>
            <span className='global-text-16'>Manifest No</span>
          </div>
          <div className='col-md-6 boldglobaltext text-break'>
            {data?.manifest_no ? data?.manifest_no : 'N/A'}
          </div>
        </div>
        <div className='row mt-2'>
          <div className='col-md-6'>
            <span className='global-text-16'>Manifest Origin</span>
          </div>
          <div className='col-md-6 boldglobaltext text-break'>
            {data?.manifest_origin ? data?.manifest_origin : 'N/A'}
          </div>
        </div>
        <div className='row mt-2'>
          <div className='col-md-6'>
            <span className='global-text-16'>Manifest Destination</span>
          </div>
          <div className='col-md-6 boldglobaltext text-break'>
            {data?.manifest_destination ? data?.manifest_destination : 'N/A'}
          </div>
        </div>
        <div className='row mt-2'>
          <div className='col-md-6'>
            <span className='global-text-16'>Last Manifest No</span>
          </div>
          <div className='col-md-6 boldglobaltext text-break'>
            {data?.last_manifest_no ? data?.last_manifest_no : 'N/A'}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Manifest;
